var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonJoin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 80,
    viewBox: "0 0 276 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.822 68.7185H216.237V69.3039V79.4147H18.5306L0.58533 56.9379V0.58533H256.899L274.845 23.0622V79.4147H251.271L245.646 69.0252L245.48 68.7185H245.132H216.822Z",
    fill: "url(#paint0_radial_8829_14395)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.822 68.7185H216.237V69.3039V79.4147H18.5306L0.58533 56.9379V0.58533H256.899L274.845 23.0622V79.4147H251.271L245.646 69.0252L245.48 68.7185H245.132H216.822Z",
    fill: "url(#paint1_radial_8829_14395)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.822 68.7185H216.237V69.3039V79.4147H18.5306L0.58533 56.9379V0.58533H256.899L274.845 23.0622V79.4147H251.271L245.646 69.0252L245.48 68.7185H245.132H216.822Z",
    stroke: "url(#paint2_linear_8829_14395)",
    strokeWidth: 1.17066,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.711 75.6098L225.183 78.4884L228.171 76.5812V79.9955H229.644V74.2812L225.183 77.1384L220.711 74.2812V75.6098Z",
    fill: "#4EE875"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M230.164 79.917V79.9955H236.108V79.0384H231.647L230.164 79.917ZM230.164 74.2812L231.647 75.2384H236.108V74.2812H230.164ZM230.164 76.667V77.617H231.647H236.108V76.667H231.647H230.164Z",
    fill: "#4EE875"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M237.253 74.2812V75.2384V79.9955H238.748V75.2384H241.714V74.2812H237.253Z",
    fill: "#4EE875"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M243.232 78.0955L244.548 76.417L245.853 78.0955H247.525L244.548 74.2812L240.087 79.9955H241.738L242.496 79.0384L243.232 78.0955ZM248.261 79.0455H246.611L247.347 79.9955H249.009L248.261 79.0455Z",
    fill: "#4EE875"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8829_14395",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.573 2.64002e-06) rotate(90) scale(44.2932 605.221)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232721",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8829_14395",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.186 79.7278) rotate(-90) scale(32.8099 195.018)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DED83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232721",
    stopOpacity: 0.43
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8829_14395",
    x1: 137.715,
    y1: 79.9997,
    x2: 137.715,
    y2: 0.0000572202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BF49D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FF1C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonJoin);
export default __webpack_public_path__ + "static/media/button-join.82cdfeb9906b5f95fbf5b2b2a73317cc.svg";
export { ForwardRef as ReactComponent };